export default "__VITE_ASSET__C7GOGok5__"